import React, { Fragment, useEffect, useState } from 'react'
import HeroSection from '../components/common/HeroSection';
import CTASection from '../components/common/CTASection';
import ConditionsGrid from '../components/Conditions/ConditionsCard';
import DigitalHealthFAB from '../components/Digitalhealth';
import { BASE_URL } from '../api/apiClient';

const isActive = (item) => item.status !== 0;

const byOrder = (arr) =>
  arr
    .map((item, index) => ({ item, index }))
    .sort((a, b) => {
      const diff = (a.item.order ?? 0) - (b.item.order ?? 0);
      return diff !== 0 ? diff : a.index - b.index;
    })
    .map(({ item }) => item);

const Conditions = () => {
  const [query, setQuery] = useState('');
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchConditions = async () => {
      try {
        const res = await fetch(`${BASE_URL}/api/femcare/conditions/`);
        const json = await res.json().catch(() => ({}));
        if (!res.ok) throw new Error(json?.error || `Request failed (${res.status})`);
        console.log(json, "this is the json")
        setData(json);
      } catch (e) {
        setError(e.message);
      } finally {
        setLoading(false);
      }
    };
    fetchConditions();
  }, []);

  // MUST come before the destructure below — `data` is null on every
  // render until the fetch resolves, so destructuring it unconditionally
  // crashes on first paint.
  if (loading || error || !data) return null;

  const { conditions: conditionsSection, callToAction } = data;
  // if (conditionsSection?.enabled === false) return null;

  const { slides } = conditionsSection.hero;
  const activeConditions = byOrder((conditionsSection.conditions || []).filter(isActive));

  return (
    <Fragment>
      <div style={{ backgroundColor: '#F4F6FA' }}>
        <DigitalHealthFAB />
        {conditionsSection?.hero?.enabled && (
          <HeroSection slides={slides} />
        )}
        <div className="w-full pt-10 pb-2">
          {conditionsSection?.enabled && <ConditionsGrid query={query} items={activeConditions} />
          }
        </div>

        {callToAction?.enabled && <CTASection data={callToAction} />}
      </div>
    </Fragment>
  );
};

export default Conditions;